import { Maybe, fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';

import Main from '../../BrowserSupport/Main';
import NotificationSource from '../../NotificationSource';
import Notifications from '../../Notifications';
import ReportStore from '../../ReportStore';
import ReportReactions from '../../ReportStore/ReportReaction';
import I18nTitle from '../../Title/I18nTitle';
import MainNav from '../Platform/MainNav';
import ReportState from './ReportState';

interface Props {
  readonly id?: string;
}

@observer
class ReportDashboard extends React.Component<Props, {}> {
  private reportStore: ReportStore = new ReportStore();
  private reportId: Maybe<number>;

  constructor(props: Props) {
    super(props);
    this.reportStore.loading();
    this.reportId = fromNullable(this.props.id).map(Number);
  }

  render() {
    return (
      <>
        <I18nTitle title="Reports" />
        <div>
          <MainNav />
          <Notifications />
          <Main id="main" className="min-h-[calc(100vh-230px)]">
            <NotificationSource store={this.reportStore} />
            <ReportState store={this.reportStore} />
            <ReportReactions
              store={this.reportStore}
              reportId={this.reportId}
              fireImmediately={true}
            />
          </Main>
        </div>
      </>
    );
  }
}

export default ReportDashboard;
